import { styled } from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 450px;
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  overflow: hidden;

  @media (max-width: 768px) {
    height: auto;
  }
`;

export const Inner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: calc(100% - 32px);
  width: 40%;
  max-width: 600px;
  min-width: 450px;
  display: flex;
  gap: ${({ theme }) => theme.spacing[5]};
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  margin: ${({ theme }) => theme.spacing[4]};
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
  padding: ${({ theme }) => theme.spacing[4]};

  @media (max-width: 768px) {
    position: relative;
    min-width: initial;
    width: 100%;
    padding: ${({ theme }) => theme.spacing[5]};
    margin: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const List = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
`;

export const Spacer = styled.div`
  flex: 1;
`;

export const Label = styled.div`
  font-size: ${({ theme }) => theme.fonts.base.fontSize};
  padding-bottom: ${({ theme }) => theme.spacing[1]};
  padding-right: ${({ theme }) => theme.spacing[1]};
  color: ${({ theme }) => theme.colors.text.secondary.color};
  font-weight: 500;
`;

export const Title = styled.div`
  font-size: ${({ theme }) => theme.fonts["3xl"].fontSize};
`;

export const Value = styled.div`
  font-size: ${({ theme }) => theme.fonts.base.fontSize};
  padding-bottom: ${({ theme }) => theme.spacing[3]};
  text-align: right;
`;

export const MapWrapper = styled.div`
  height: 450px;

  @media (max-width: 768px) {
    height: 300px;
  }
`;
